"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.piecesWithoutCreations = exports.piecesList = exports.getVariousPricingsItemsForCreation = exports.getVariousPricingsCategory = exports.getRepairInteriorZips = exports.getRepairInteriorTears = exports.getRepairInteriorButtons = exports.getPricingsItemsWithIds = exports.getFilteredVariousPricingsItems = exports.getEmbroideryPricingsCategory = exports.getCommunZipsRepair = exports.getCommunZipsAlteration = exports.getCommunTearRepair = exports.getCommunMachineEmbroidery = exports.getCommunButtonsRepair = exports.getCommunButtonsAlteration = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *** Version: 13 ***

/* eslint max-len: 0, object-curly-newline: 0 */

var version = 13;
var piecesList = exports.piecesList = ['pant', 'haut', 'robe', 'mari', 'mant', 'jupe', 'pull', 'comb', 'ling', 'acce', 'littles_acce', 'ride', 'mais', 'cous', 'chair', 'sofa', 'tableClothes', 'crea_tote', 'crea_sac', 'crea_poch', 'crea_hous', 'crea_assi', 'crea_doss', 'crea_cana', 'crea_plai', 'crea_chai', 'crea_stoo', 'crea_ride'];
var interiorPiecesList = ['ride', 'mais', 'cous', 'chair', 'sofa', 'tableClothes'];
var piecesWithoutCreations = exports.piecesWithoutCreations = piecesList.filter(function (piece) {
  return !piece.startsWith('crea_');
});
var SMALL_ZIP = 'Zip court (< 25cm) fourni par le Tilliste : réparation / remplacement';
var TEAR = 'Déchirure : couture simple';
var SIMPLE_EXTRA_SEAM = 'Couture décousue simple';
var PARTIAL_LINING = 'Doublure : changement partiel';
var BUTTON = 'Bouton (x1) fourni par le Tilliste : ajout / remplacement';
var HOLE = 'Trou : raccommodage simple';
var ELBOW = 'Coudières (x2) : ajout / remplacement';
var BUTTONHOLE = 'Boutonnière (x1) : création';
var ELASTIC = 'Élastique : ajout';
var HOOK = 'Crochets  (x1) : ajout / remplacement';
var mostCommonCategoryPositions = {
  mant: [{
    name: PARTIAL_LINING,
    position: 3
  }, {
    name: SMALL_ZIP,
    position: 4
  }, {
    name: TEAR,
    position: 5
  }],
  haut: [{
    name: BUTTON,
    position: 1
  }, {
    name: TEAR,
    position: 2
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 3
  }],
  pant: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }],
  jupe: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }],
  robe: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }],
  pull: [{
    name: HOLE,
    position: 1
  }, {
    name: ELBOW,
    position: 2
  }, {
    name: BUTTONHOLE,
    position: 3
  }, {
    name: BUTTON,
    position: 4
  }],
  ling: [{
    name: TEAR,
    position: 1
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 2
  }, {
    name: ELASTIC,
    position: 3
  }],
  comb: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }],
  mari: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }]
};
var getPricingsItemsWithIds = exports.getPricingsItemsWithIds = function getPricingsItemsWithIds(items, categorySlug, slug, type) {
  var minIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var isSuitableForJunior = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return items.map(function (pricing, index) {
    var _mostCommonCategoryPo;
    var newIndex = minIndex + index + 1;
    var name = pricing.name,
      prices = pricing.prices,
      liningPrices = pricing.liningPrices,
      multiple = pricing.multiple,
      itemPosition = pricing.itemPosition,
      hidden = pricing.hidden,
      repairBonus = pricing.repairBonus;
    var updatedPrices = type ? {
      DEFAULT: prices[type]
    } : _objectSpread({}, prices);
    delete updatedPrices.mari;
    var updatedLiningPrices;
    if (type) {
      if (liningPrices !== null && liningPrices !== void 0 && liningPrices[type]) updatedLiningPrices = liningPrices !== null && liningPrices !== void 0 && liningPrices[type] ? {
        DEFAULT: liningPrices[type]
      } : undefined;
    } else {
      updatedLiningPrices = _objectSpread({}, liningPrices);
    }
    if (updatedLiningPrices) delete updatedLiningPrices.mari;
    if (updatedLiningPrices && Object.keys(updatedLiningPrices).length === 0) updatedLiningPrices = undefined;
    var item = {
      name: name,
      prices: updatedPrices,
      id: "".concat(version, ".").concat(slug, "-").concat(categorySlug, "-").concat(newIndex),
      itemPosition: itemPosition
    };
    if (isSuitableForJunior) item.isSuitableForJunior = isSuitableForJunior;
    if (updatedLiningPrices) item.liningPrices = updatedLiningPrices;
    if (multiple) item.multiple = multiple;
    if (hidden) item.hidden = hidden;
    if (repairBonus) item.repairBonus = repairBonus;
    if ((_mostCommonCategoryPo = mostCommonCategoryPositions[slug]) !== null && _mostCommonCategoryPo !== void 0 && _mostCommonCategoryPo.find(function (mostCommon) {
      return mostCommon.name === name;
    })) {
      item.mostCommonCategoryPosition = mostCommonCategoryPositions[slug].find(function (mostCommon) {
        return mostCommon.name === name;
      }).position;
    }
    return item;
  }).sort(function (itemA, itemB) {
    return itemA.itemPosition - itemB.itemPosition;
  });
};
var embroideryPricingsItems = [{
  itemPosition: 1,
  name: 'Initiales',
  prices: {
    SIMPLE: 10,
    COMPLEX: 10,
    mari: 20
  },
  multiple: true
}, {
  itemPosition: 2,
  name: 'Un mot (10 lettres - petite police)',
  prices: {
    SIMPLE: 15,
    COMPLEX: 15,
    mari: 28
  },
  multiple: true
}, {
  itemPosition: 3,
  name: 'Un mot (10 lettres - grosse police)',
  prices: {
    SIMPLE: 45,
    COMPLEX: 45,
    mari: 52
  },
  multiple: true
}, {
  itemPosition: 4,
  name: 'Un mot (10 lettres - grosse police pleine)',
  prices: {
    SIMPLE: 80,
    COMPLEX: 80,
    mari: 110
  },
  multiple: true
}, {
  itemPosition: 5,
  name: 'Dessin creux forme simple < 5cm',
  prices: {
    SIMPLE: 10,
    COMPLEX: 10,
    mari: 18
  },
  multiple: true
}, {
  itemPosition: 6,
  name: 'Dessin creux forme simple < 12cm',
  prices: {
    SIMPLE: 17,
    COMPLEX: 17,
    mari: 25
  },
  multiple: true
}, {
  itemPosition: 7,
  name: 'Dessin creux forme simple < 25cm',
  prices: {
    SIMPLE: 25,
    COMPLEX: 25,
    mari: 35
  },
  multiple: true
}, {
  itemPosition: 8,
  name: 'Dessin plein forme simple < 5cm',
  prices: {
    SIMPLE: 35,
    COMPLEX: 35,
    mari: 48
  },
  multiple: true
}, {
  itemPosition: 9,
  name: 'Dessin plein complexe < 5cm',
  prices: {
    SIMPLE: 65,
    COMPLEX: 65,
    mari: 80
  },
  multiple: true
}, {
  itemPosition: 10,
  name: 'Dessin plein forme simple < 12cm',
  prices: {
    SIMPLE: 55,
    COMPLEX: 55,
    mari: 71
  },
  multiple: true
}, {
  itemPosition: 11,
  name: 'Dessin plein complexe < 12cm',
  prices: {
    SIMPLE: 130,
    COMPLEX: 130,
    mari: 200
  },
  multiple: true
}, {
  itemPosition: 12,
  name: 'Dessin creux complexe < 5cm',
  prices: {
    SIMPLE: 15,
    COMPLEX: 15,
    mari: 25
  },
  multiple: true
}, {
  itemPosition: 13,
  name: 'Dessin creux complexe < 12cm',
  prices: {
    SIMPLE: 25,
    COMPLEX: 25,
    mari: 35
  },
  multiple: true
}, {
  itemPosition: 14,
  name: 'Dessin creux complexe < 25cm',
  prices: {
    SIMPLE: 40,
    COMPLEX: 40,
    mari: 45
  },
  multiple: true
}];
var getCommunMachineEmbroidery = exports.getCommunMachineEmbroidery = function getCommunMachineEmbroidery(_ref) {
  var slug = _ref.slug;
  return {
    name: 'Broderie machine',
    slug: 'machine_embroidery',
    items: [{
      name: 'Texte (15 lettres maximum) ≤ 0.5cm',
      prices: interiorPiecesList.includes(slug) ? {
        DEFAULT: 12
      } : {
        SIMPLE: 12,
        COMPLEX: 12
      },
      id: "14.".concat(slug, "-bro-15"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Texte (15 lettres maximum) ≤ 2cm',
      prices: interiorPiecesList.includes(slug) ? {
        DEFAULT: 15
      } : {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: "14.".concat(slug, "-bro-16"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Texte (15 lettres maximum) ≤ 3cm',
      prices: interiorPiecesList.includes(slug) ? {
        DEFAULT: 20
      } : {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: "14.".concat(slug, "-bro-17"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Dessin creux ≤ 0.5cm',
      prices: interiorPiecesList.includes(slug) ? {
        DEFAULT: 12
      } : {
        SIMPLE: 12,
        COMPLEX: 12
      },
      id: "14.".concat(slug, "-bro-18"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Dessin creux ≤ 2cm',
      prices: interiorPiecesList.includes(slug) ? {
        DEFAULT: 15
      } : {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: "14.".concat(slug, "-bro-19"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Dessin creux ≤ 3cm',
      prices: interiorPiecesList.includes(slug) ? {
        DEFAULT: 20
      } : {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: "14.".concat(slug, "-bro-20"),
      multiple: true,
      isSuitableForJunior: true
    }]
  };
};
var getEmbroideryPricingsCategory = exports.getEmbroideryPricingsCategory = function getEmbroideryPricingsCategory(slug, type) {
  return {
    name: 'Broderie main',
    slug: 'hand_embroidery',
    items: getPricingsItemsWithIds(embroideryPricingsItems, 'bro', slug, type)
  };
};

// using it for creation and upcycling
var variousPricingsItems = [{
  itemPosition: 1,
  name: 'Bretelles (x2) : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 12,
    COMPLEX: 18,
    mari: 45
  },
  pieces: ['haut', 'robe', 'jupe', 'mari', 'comb', 'ling'],
  hidden: true
}, {
  itemPosition: 2,
  name: 'Épaulettes (x2) : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 18,
    COMPLEX: 21,
    mari: 35
  },
  liningPrices: {
    SIMPLE: 2,
    COMPLEX: 2,
    mari: 8
  },
  pieces: ['mant', 'haut', 'robe', 'pull', 'comb', 'mari'],
  hidden: true
}, {
  itemPosition: 3,
  name: ELBOW,
  prices: {
    SIMPLE: 17,
    COMPLEX: 20
  },
  pieces: ['haut', 'pull', 'comb', 'mant'],
  hidden: true
}, {
  itemPosition: 4,
  name: 'Attache dos : remplacement',
  prices: {
    SIMPLE: 10,
    COMPLEX: 15
  },
  multiple: true,
  pieces: ['ling'],
  hidden: true
}, {
  itemPosition: 5,
  name: 'Baleines (x2) : remplacement / réparation',
  prices: {
    SIMPLE: 12,
    COMPLEX: 17
  },
  liningPrices: {
    SIMPLE: 8,
    COMPLEX: 17
  },
  multiple: true,
  pieces: ['ling'],
  hidden: true
}, {
  itemPosition: 6,
  name: 'Ceinture : ajout / remplacement',
  prices: {
    mari: 42
  },
  multiple: true,
  pieces: ['mari'],
  hidden: true
}, {
  itemPosition: 7,
  name: 'Passant (x1) : ajout / remplacement',
  prices: {
    SIMPLE: 4,
    COMPLEX: 8,
    mari: 10
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 8,
  name: 'Genouillères (x2) : ajout / remplacement',
  prices: {
    SIMPLE: 17,
    COMPLEX: 20
  },
  pieces: ['pant', 'comb'],
  hidden: true
}, {
  itemPosition: 9,
  name: 'Pince (x1) : ajout',
  prices: {
    SIMPLE: 8,
    COMPLEX: 12,
    mari: 25
  },
  liningPrices: {
    SIMPLE: 1,
    COMPLEX: 1,
    mari: 5
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 10,
  name: 'Fente : ajout / retrait',
  prices: {
    SIMPLE: 12,
    COMPLEX: 18,
    mari: 29
  },
  liningPrices: {
    SIMPLE: 4,
    COMPLEX: 6,
    mari: 6
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 11,
  name: ELASTIC,
  prices: {
    SIMPLE: 7,
    COMPLEX: 17,
    mari: 22
  },
  liningPrices: {
    SIMPLE: 1,
    COMPLEX: 1,
    mari: 3
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 12,
  name: 'Perlage (5 à 10 perles)',
  prices: {
    SIMPLE: 15,
    COMPLEX: 17,
    mari: 35
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 13,
  name: 'Doublure : changement intégral',
  prices: {
    COMPLEX: 105
  },
  pieces: ['mant'],
  repairBonus: 'LINING_COMPLEX',
  hidden: true
}, {
  itemPosition: 14,
  name: PARTIAL_LINING,
  prices: {
    COMPLEX: 45
  },
  pieces: ['mant'],
  repairBonus: 'LINING_COMPLEX',
  hidden: true
}, {
  itemPosition: 15,
  name: 'Doublure : ajout / remplacement',
  prices: {
    SIMPLE: 35,
    COMPLEX: 55,
    mari: 69
  },
  pieces: piecesWithoutCreations.filter(function (piece) {
    return !['mant', 'robe', 'pant', 'jupe'].includes(piece);
  }),
  repairBonus: {
    SIMPLE: 'LINING_SIMPLE',
    COMPLEX: 'LINING_COMPLEX',
    mari: 'LINING_COMPLEX'
  },
  hidden: true
}, {
  itemPosition: 15.5,
  name: 'Doublure : ajout / remplacement',
  prices: {
    SIMPLE: 42,
    COMPLEX: 49
  },
  pieces: ['robe', 'pant', 'jupe'],
  repairBonus: 'LINING_SIMPLE',
  hidden: true
}, {
  itemPosition: 16,
  name: 'Poche (x1) : changement de doublure',
  prices: {
    SIMPLE: 10,
    COMPLEX: 12,
    mari: 15
  },
  multiple: true,
  pieces: piecesWithoutCreations,
  repairBonus: 'LINING_SIMPLE',
  hidden: true
}, {
  itemPosition: 17,
  name: 'Poche plate simple (x1) : ajout',
  prices: {
    SIMPLE: 10,
    COMPLEX: 15,
    mari: 18
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 18,
  name: 'Poche intérieure classique (x1) : ajout',
  prices: {
    SIMPLE: 15,
    COMPLEX: 19,
    mari: 22
  },
  multiple: true,
  pieces: piecesWithoutCreations,
  hidden: true
}, {
  itemPosition: 19,
  name: 'Poche complexe (x1) : ajout',
  prices: {
    SIMPLE: 20,
    COMPLEX: 22,
    mari: 27
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 20,
  name: BUTTONHOLE,
  prices: {
    SIMPLE: 3,
    COMPLEX: 4,
    mari: 10
  },
  liningPrices: {
    SIMPLE: 1,
    COMPLEX: 1,
    mari: 2
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 21,
  name: BUTTON,
  prices: {
    SIMPLE: 3,
    COMPLEX: 3,
    mari: 4
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 23,
  name: 'Bouton pression (x1) fourni par le client : ajout / remplacement',
  prices: {
    SIMPLE: 6,
    COMPLEX: 8,
    mari: 10
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 22,
  name: 'Bouton (x1) fourni par le client : ajout / remplacement',
  prices: {
    SIMPLE: 2,
    COMPLEX: 2,
    mari: 2
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 24,
  name: SMALL_ZIP,
  prices: {
    SIMPLE: 22,
    COMPLEX: 22,
    mari: 22
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_SMALL'
}, {
  itemPosition: 25,
  name: 'Zip long (40-80cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 45,
    COMPLEX: 45,
    mari: 45
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 12
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_BIG'
}, {
  itemPosition: 26,
  name: 'Zip invisible court (< 25cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 26,
    COMPLEX: 26,
    mari: 26
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 12
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_SMALL'
}, {
  itemPosition: 27,
  name: 'Zip invisible long (40-80cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 53,
    COMPLEX: 53,
    mari: 53
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 15
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_BIG'
}, {
  itemPosition: 37,
  name: 'Couture complexe avec empiècement',
  prices: {
    SIMPLE: 15,
    COMPLEX: 17,
    mari: 35
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 39,
  name: 'Upcycling sur-mesure',
  prices: {
    SIMPLE: 30,
    COMPLEX: 35,
    mari: 35
  },
  multiple: true,
  pieces: piecesList,
  categories: ['upc']
}, {
  itemPosition: 28,
  name: 'Zip court (< 25cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 19,
    COMPLEX: 19,
    mari: 47
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_SMALL'
}, {
  itemPosition: 29,
  name: 'Zip long (40-80cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 40,
    COMPLEX: 40,
    mari: 53
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 12
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_BIG'
}, {
  itemPosition: 30,
  name: 'Zip invisible court (< 25cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 23,
    COMPLEX: 23,
    mari: 43
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 12
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_SMALL'
}, {
  itemPosition: 31,
  name: 'Zip invisible long (40-80cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 48,
    COMPLEX: 48,
    mari: 50
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 15
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_BIG'
}, {
  itemPosition: 40,
  name: 'Scratch < 30cm',
  prices: {
    SIMPLE: 5,
    COMPLEX: 9
  },
  multiple: true,
  pieces: piecesList.filter(function (piece) {
    return !['mari'].includes(piece);
  }),
  hidden: true
}, {
  itemPosition: 41,
  name: 'Scratch > 30cm',
  prices: {
    SIMPLE: 7,
    COMPLEX: 11
  },
  multiple: true,
  pieces: piecesList.filter(function (piece) {
    return !['mari'].includes(piece);
  }),
  hidden: true
}, {
  itemPosition: 38,
  name: 'Couture complexe - 2 empiècements identiques (fourni par client)',
  prices: {
    SIMPLE: 25,
    COMPLEX: 25
  },
  multiple: true,
  pieces: piecesList.filter(function (piece) {
    return !['mari'].includes(piece);
  }),
  hidden: true
}, {
  itemPosition: 42,
  name: 'Oeillet petit (x1) : ajout',
  prices: {
    SIMPLE: 1,
    COMPLEX: 1,
    mari: 2
  },
  multiple: true,
  pieces: ['mari', 'ling', 'haut', 'robe', 'jupe', 'pull', 'comb', 'acce'],
  hidden: true
}, {
  itemPosition: 43,
  name: 'Oeillet petit (x1) : ajout',
  prices: {
    COMPLEX: 2
  },
  multiple: true,
  pieces: ['mant'],
  hidden: true
}, {
  itemPosition: 44,
  name: 'Oeillet moyen (x1) : ajout',
  prices: {
    SIMPLE: 4,
    COMPLEX: 4
  },
  multiple: true,
  pieces: ['acce', 'ride'],
  hidden: true
}, {
  itemPosition: 45,
  name: HOOK,
  prices: {
    SIMPLE: 6,
    COMPLEX: 8,
    mari: 10
  },
  multiple: true,
  pieces: ['pant', 'haut', 'robe', 'mari', 'jupe', 'mant', 'pull', 'ling'],
  hidden: true
}, {
  itemPosition: 21.4,
  name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
  prices: {
    SIMPLE: 3,
    COMPLEX: 3,
    mari: 3
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 23.2,
  name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
  prices: {
    SIMPLE: 2,
    COMPLEX: 2,
    mari: 2
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 21.7,
  name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
  prices: {
    SIMPLE: 8,
    COMPLEX: 8,
    mari: 8
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 23.5,
  name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
  prices: {
    SIMPLE: 6,
    COMPLEX: 6,
    mari: 6
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 24.5,
  name: 'Zip moyen (25-40cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 37,
    COMPLEX: 39,
    mari: 43
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 26.5,
  name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 46,
    COMPLEX: 46,
    mari: 60
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 28.5,
  name: 'Zip moyen (25-40cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 35,
    COMPLEX: 37,
    mari: 43
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 30.5,
  name: 'Zip invisible moyen (25-40cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 42,
    COMPLEX: 42,
    mari: 47
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 32.5,
  name: 'Couture de finition',
  prices: {
    SIMPLE: 4,
    COMPLEX: 4,
    mari: 4
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}];
var getCommunTearRepair = exports.getCommunTearRepair = function getCommunTearRepair(_ref2) {
  var slug = _ref2.slug,
    _ref2$isSuitableForJu = _ref2.isSuitableForJunior,
    isSuitableForJunior = _ref2$isSuitableForJu === void 0 ? false : _ref2$isSuitableForJu;
  var items = [{
    name: TEAR,
    prices: {
      SIMPLE: 12,
      COMPLEX: 16,
      mari: 21
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-tear-1"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'HOLE'
  }, {
    name: 'Déchirure : couture complexe avec empiècement',
    prices: {
      SIMPLE: 15,
      COMPLEX: 19
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-tear-2"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'HOLE'
  }, {
    name: SIMPLE_EXTRA_SEAM,
    prices: {
      SIMPLE: 4,
      COMPLEX: 6
    },
    liningPrices: {
      SIMPLE: 2,
      COMPLEX: 2
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-tear-3"),
    multiple: true,
    repairBonus: 'UNTIED_UNLINED'
  }, {
    name: 'Couture décousue complexe',
    prices: {
      SIMPLE: 10,
      COMPLEX: 12
    },
    liningPrices: {
      SIMPLE: 2,
      COMPLEX: 2
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-tear-4"),
    multiple: true,
    repairBonus: 'UNTIED_UNLINED'
  }, {
    name: HOLE,
    prices: {
      SIMPLE: 6,
      COMPLEX: 6
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-tear-5"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'HOLE'
  }, {
    name: 'Trou : raccommodage complexe',
    prices: {
      SIMPLE: 17,
      COMPLEX: 17
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-tear-6"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'HOLE'
  }, {
    name: 'Trou : remaillage simple',
    prices: {
      SIMPLE: 25,
      COMPLEX: 25
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-tear-7"),
    multiple: true,
    repairBonus: 'HOLE',
    potentialFabrics: ['stitch']
  }, {
    name: 'Trou : remaillage complexe',
    prices: {
      SIMPLE: 40,
      COMPLEX: 40
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-tear-8"),
    multiple: true,
    repairBonus: 'HOLE',
    potentialFabrics: ['stitch']
  }];
  items.forEach(function (item) {
    var _mostCommonCategoryPo2;
    var mostCommonCat = (_mostCommonCategoryPo2 = mostCommonCategoryPositions[slug]) === null || _mostCommonCategoryPo2 === void 0 ? void 0 : _mostCommonCategoryPo2.find(function (mostCommon) {
      return mostCommon.name === item.name;
    });
    if (mostCommonCat) {
      item.mostCommonCategoryPosition = mostCommonCat.position;
    }
  });
  return {
    name: 'Déchirures / trous',
    slug: 'tear_repair',
    items: items
  };
};
var getCommunZipsRepair = exports.getCommunZipsRepair = function getCommunZipsRepair(_ref3) {
  var slug = _ref3.slug,
    _ref3$isSuitableForJu = _ref3.isSuitableForJunior,
    isSuitableForJunior = _ref3$isSuitableForJu === void 0 ? false : _ref3$isSuitableForJu;
  var items = [{
    name: SMALL_ZIP,
    prices: {
      SIMPLE: 22,
      COMPLEX: 22
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-1"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_SMALL'
  }, {
    name: 'Zip moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 37,
      COMPLEX: 39
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-2"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip long (40-80cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 45,
      COMPLEX: 47
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-3"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip invisible court (< 25cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 26,
      COMPLEX: 28
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-4"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_SMALL'
  }, {
    name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 46,
      COMPLEX: 48
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-5"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip invisible long (40-80cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 53,
      COMPLEX: 55
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-6"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip court (< 25cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 19,
      COMPLEX: 22
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-7"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_SMALL'
  }, {
    name: 'Zip moyen (25-40cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 35,
      COMPLEX: 37
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-8"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip long (40-80cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 40,
      COMPLEX: 42
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-9"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip invisible court (< 25cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 23,
      COMPLEX: 25
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-10"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_SMALL'
  }, {
    name: 'Zip invisible moyen (25-40cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 42,
      COMPLEX: 44
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-11"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip invisible long (40-80cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 48,
      COMPLEX: 50
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-12"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip très long (>80cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 51,
      COMPLEX: 53
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-13"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip très long (>80cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 46,
      COMPLEX: 48
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-zip-14"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }];
  items.forEach(function (item) {
    var _mostCommonCategoryPo3;
    var mostCommonCat = (_mostCommonCategoryPo3 = mostCommonCategoryPositions[slug]) === null || _mostCommonCategoryPo3 === void 0 ? void 0 : _mostCommonCategoryPo3.find(function (mostCommon) {
      return mostCommon.name === item.name;
    });
    if (mostCommonCat) {
      item.mostCommonCategoryPosition = mostCommonCat.position;
    }
  });
  return {
    name: 'Zips',
    slug: 'zip_repair',
    items: items
  };
};
var getCommunZipsAlteration = exports.getCommunZipsAlteration = function getCommunZipsAlteration(_ref4) {
  var slug = _ref4.slug,
    _ref4$isSuitableForJu = _ref4.isSuitableForJunior,
    isSuitableForJunior = _ref4$isSuitableForJu === void 0 ? false : _ref4$isSuitableForJu;
  return {
    name: 'Zips',
    slug: 'zip_alteration',
    onlyCouturiers: true,
    items: [{
      name: 'Zip court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
      prices: {
        SIMPLE: 22,
        COMPLEX: 22
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-1"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
      prices: {
        SIMPLE: 37,
        COMPLEX: 39
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-2"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
      prices: {
        SIMPLE: 45,
        COMPLEX: 45
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-3"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip invisible court (< 25cm) fourni par le Tilliste : retouche / ajout / retrait',
      prices: {
        SIMPLE: 26,
        COMPLEX: 26
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-4"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : retouche / ajout / retrait',
      prices: {
        SIMPLE: 46,
        COMPLEX: 46
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-5"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip invisible long (40-80cm) fourni par le Tilliste : retouche / ajout / retrait',
      prices: {
        SIMPLE: 53,
        COMPLEX: 53
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-6"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip court (< 25cm) fourni par le client : retouche / ajout / retrait',
      prices: {
        SIMPLE: 19,
        COMPLEX: 19
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-7"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip moyen (25-40cm) fourni par le client : retouche / ajout / retrait',
      prices: {
        SIMPLE: 35,
        COMPLEX: 37
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-8"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip long (40-80cm) fourni par le client : retouche / ajout / retrait',
      prices: {
        SIMPLE: 40,
        COMPLEX: 42
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-9"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip invisible court (< 25cm) fourni par le client : retouche / ajout / retrait',
      prices: {
        SIMPLE: 23,
        COMPLEX: 25
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-10"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip invisible moyen (25-40cm) fourni par le client : retouche / ajout / retrait',
      prices: {
        SIMPLE: 42,
        COMPLEX: 44
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-11"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip invisible long (40-80cm) fourni par le client : retouche / ajout / retrait',
      prices: {
        SIMPLE: 48,
        COMPLEX: 50
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-12"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip très long (>80cm) fourni par le Tilliste : retouche / ajout / retrait',
      prices: {
        SIMPLE: 51,
        COMPLEX: 53
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-13"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }, {
      name: 'Zip très long (>80cm) fourni par le client : retouche / ajout / retrait',
      prices: {
        SIMPLE: 46,
        COMPLEX: 48
      },
      liningPrices: {
        SIMPLE: 5,
        COMPLEX: 5
      },
      atShop: true,
      id: "14.".concat(slug, "-ret-zip-14"),
      multiple: true,
      isSuitableForJunior: isSuitableForJunior,
      onlyCouturiers: true
    }]
  };
};
var getCommunButtonsRepair = exports.getCommunButtonsRepair = function getCommunButtonsRepair(_ref5) {
  var slug = _ref5.slug,
    _ref5$isSuitableForJu = _ref5.isSuitableForJunior,
    isSuitableForJunior = _ref5$isSuitableForJu === void 0 ? false : _ref5$isSuitableForJu;
  var items = [{
    name: BUTTONHOLE,
    prices: {
      SIMPLE: 3,
      COMPLEX: 4
    },
    liningPrices: {
      SIMPLE: 1,
      COMPLEX: 1
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-but-1"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: BUTTON,
    prices: {
      SIMPLE: 3,
      COMPLEX: 3
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-but-2"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton (x1) fourni par le client : ajout / remplacement',
    prices: {
      SIMPLE: 2,
      COMPLEX: 2
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-but-4"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
    prices: {
      SIMPLE: 3,
      COMPLEX: 3
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-but-5"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
    prices: {
      SIMPLE: 2,
      COMPLEX: 2
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-but-6"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
    prices: {
      SIMPLE: 8,
      COMPLEX: 8
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-but-7"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
    prices: {
      SIMPLE: 6,
      COMPLEX: 6
    },
    atShop: true,
    id: "14.".concat(slug, "-rep-but-8"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }];
  items.forEach(function (item) {
    var _mostCommonCategoryPo4;
    var mostCommonCat = (_mostCommonCategoryPo4 = mostCommonCategoryPositions[slug]) === null || _mostCommonCategoryPo4 === void 0 ? void 0 : _mostCommonCategoryPo4.find(function (mostCommon) {
      return mostCommon.name === item.name;
    });
    if (mostCommonCat) {
      item.mostCommonCategoryPosition = mostCommonCat.position;
    }
  });
  return {
    name: 'Boutons',
    slug: 'but_repair',
    items: items
  };
};
var getCommunButtonsAlteration = exports.getCommunButtonsAlteration = function getCommunButtonsAlteration(_ref6) {
  var slug = _ref6.slug,
    _ref6$isSuitableForJu = _ref6.isSuitableForJunior,
    isSuitableForJunior = _ref6$isSuitableForJu === void 0 ? false : _ref6$isSuitableForJu;
  return {
    name: 'Boutons',
    slug: 'but_alteration',
    onlyCouturiers: true,
    items: [{
      name: 'Boutonnière (x1) : création',
      prices: {
        SIMPLE: 3,
        COMPLEX: 4
      },
      liningPrices: {
        SIMPLE: 1,
        COMPLEX: 1
      },
      id: "14.".concat(slug, "-ret-but-1"),
      multiple: true,
      onlyCouturiers: true,
      isSuitableForJunior: isSuitableForJunior
    }, {
      name: 'Bouton (x1) fourni par le Tilliste : ajout / remplacement',
      prices: {
        SIMPLE: 3,
        COMPLEX: 3
      },
      id: "14.".concat(slug, "-ret-but-2"),
      multiple: true,
      onlyCouturiers: true,
      isSuitableForJunior: isSuitableForJunior
    }, {
      name: 'Bouton (x1) fourni par le client : ajout / remplacement',
      prices: {
        SIMPLE: 2,
        COMPLEX: 2
      },
      id: "14.".concat(slug, "-ret-but-4"),
      multiple: true,
      onlyCouturiers: true,
      isSuitableForJunior: isSuitableForJunior
    }, {
      name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
      prices: {
        SIMPLE: 3,
        COMPLEX: 3
      },
      id: "14.".concat(slug, "-ret-but-5"),
      multiple: true,
      onlyCouturiers: true,
      isSuitableForJunior: isSuitableForJunior
    }, {
      name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
      prices: {
        SIMPLE: 2,
        COMPLEX: 2
      },
      id: "14.".concat(slug, "-ret-but-6"),
      multiple: true,
      onlyCouturiers: true,
      isSuitableForJunior: isSuitableForJunior
    }, {
      name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
      prices: {
        SIMPLE: 8,
        COMPLEX: 8
      },
      id: "14.".concat(slug, "-ret-but-7"),
      multiple: true,
      onlyCouturiers: true,
      isSuitableForJunior: isSuitableForJunior
    }, {
      name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
      prices: {
        SIMPLE: 6,
        COMPLEX: 6
      },
      id: "14.".concat(slug, "-ret-but-8"),
      multiple: true,
      onlyCouturiers: true,
      isSuitableForJunior: isSuitableForJunior
    }]
  };
};
var getFilteredVariousPricingsItems = exports.getFilteredVariousPricingsItems = function getFilteredVariousPricingsItems(slug, category) {
  return variousPricingsItems.filter(function (_ref7) {
    var pieces = _ref7.pieces,
      categories = _ref7.categories;
    return pieces.includes(slug) && (!categories || categories.includes(category));
  });
};
var getVariousPricingsCategory = exports.getVariousPricingsCategory = function getVariousPricingsCategory(_ref8) {
  var pieceSlug = _ref8.pieceSlug,
    _ref8$name = _ref8.name,
    name = _ref8$name === void 0 ? 'Divers' : _ref8$name,
    _ref8$type = _ref8.type,
    type = _ref8$type === void 0 ? undefined : _ref8$type,
    _ref8$categorySlug = _ref8.categorySlug,
    categorySlug = _ref8$categorySlug === void 0 ? 'div' : _ref8$categorySlug,
    _ref8$minIndex = _ref8.minIndex,
    minIndex = _ref8$minIndex === void 0 ? 0 : _ref8$minIndex,
    _ref8$isSuitableForJu = _ref8.isSuitableForJunior,
    isSuitableForJunior = _ref8$isSuitableForJu === void 0 ? false : _ref8$isSuitableForJu,
    _ref8$slug = _ref8.slug,
    slug = _ref8$slug === void 0 ? 'divers' : _ref8$slug;
  return {
    name: name,
    slug: slug,
    items: getPricingsItemsWithIds(getFilteredVariousPricingsItems(pieceSlug, categorySlug), categorySlug, pieceSlug, type, minIndex, isSuitableForJunior)
  };
};
var getVariousPricingsItemsForCreation = exports.getVariousPricingsItemsForCreation = function getVariousPricingsItemsForCreation(_ref9) {
  var slug = _ref9.slug,
    _ref9$type = _ref9.type,
    type = _ref9$type === void 0 ? 'SIMPLE' : _ref9$type,
    autoComplexFactor = _ref9.autoComplexFactor,
    _ref9$isClosingsOnly = _ref9.isClosingsOnly,
    isClosingsOnly = _ref9$isClosingsOnly === void 0 ? false : _ref9$isClosingsOnly,
    _ref9$categorySlug = _ref9.categorySlug,
    categorySlug = _ref9$categorySlug === void 0 ? 'divers_crea' : _ref9$categorySlug;
  var filteredVariousPricingsItems = getFilteredVariousPricingsItems(slug);
  if (isClosingsOnly) filteredVariousPricingsItems = filteredVariousPricingsItems.filter(function (_ref10) {
    var isClosing = _ref10.isClosing;
    return isClosing;
  });
  var pricingsItems = [];
  filteredVariousPricingsItems.forEach(function (_ref11) {
    var name = _ref11.name,
      prices = _ref11.prices,
      multiple = _ref11.multiple,
      hidden = _ref11.hidden,
      itemPosition = _ref11.itemPosition;
    var item = {
      name: name,
      categorySlug: categorySlug,
      itemPosition: itemPosition
    };
    item.priceForAllTypes = prices[type];
    if (hidden) item.hidden = hidden;
    if (multiple) item.multiple = multiple;
    if (autoComplexFactor) item.autoComplexFactor = autoComplexFactor;
    pricingsItems.push(item);
  });
  return pricingsItems.sort(function (itemA, itemB) {
    if (itemA.itemPosition === undefined || itemB.itemPosition === undefined) {
      return 0;
    }
    return itemA.itemPosition - itemB.itemPosition;
  });
};

// Common interior pricings with repairBonus
var getRepairInteriorTears = exports.getRepairInteriorTears = function getRepairInteriorTears(_ref12) {
  var slug = _ref12.slug;
  return {
    name: 'Déchirures / trous',
    slug: 'tear_repair',
    items: [{
      name: 'Déchirure',
      prices: {
        DEFAULT: 16
      },
      id: "14.".concat(slug, "-rep-tear-1"),
      isSuitableForJunior: true,
      multiple: true,
      repairBonus: 'HOLE'
    }, {
      name: 'Couture complexe avec empiècement',
      prices: {
        DEFAULT: 19
      },
      id: "14.".concat(slug, "-rep-tear-2"),
      isSuitableForJunior: true,
      multiple: true,
      repairBonus: 'HOLE'
    }, {
      name: 'Trou : raccommodage simple',
      prices: {
        DEFAULT: 12
      },
      id: "14.".concat(slug, "-rep-tear-3"),
      isSuitableForJunior: true,
      multiple: true,
      repairBonus: 'HOLE'
    }, {
      name: 'Trou : raccommodage complexe',
      prices: {
        DEFAULT: 17
      },
      id: "14.".concat(slug, "-rep-tear-4"),
      isSuitableForJunior: true,
      multiple: true,
      repairBonus: 'HOLE'
    }, {
      name: 'Couture décousue simple',
      prices: {
        DEFAULT: 14
      },
      id: "14.".concat(slug, "-rep-tear-5"),
      isSuitableForJunior: true,
      multiple: true,
      onlyCouturiers: true,
      repairBonus: 'UNTIED_UNLINED'
    }, {
      name: 'Couture décousue complexe',
      prices: {
        DEFAULT: 16
      },
      id: "14.".concat(slug, "-rep-tear-6"),
      isSuitableForJunior: true,
      multiple: true,
      onlyCouturiers: true,
      repairBonus: 'UNTIED_UNLINED'
    }, {
      name: 'Scratch < 30cm : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 5
      },
      id: "14.".concat(slug, "-rep-tear-7"),
      isSuitableForJunior: true,
      multiple: true
    }, {
      name: 'Scratch > 30cm : ajout / remplacement / retrait',
      prices: {
        DEFAULT: 7
      },
      id: "14.".concat(slug, "-rep-tear-8"),
      isSuitableForJunior: true,
      multiple: true
    }]
  };
};
var getRepairInteriorZips = exports.getRepairInteriorZips = function getRepairInteriorZips(_ref13) {
  var slug = _ref13.slug;
  return {
    name: 'Zips',
    slug: 'zip_repair',
    items: [{
      name: 'Zip court (< 25cm) fourni par le Tilliste : réparation / remplacement',
      prices: {
        DEFAULT: 24
      },
      id: "14.".concat(slug, "-rep-zip-1"),
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
      prices: {
        DEFAULT: 39
      },
      id: "14.".concat(slug, "-rep-zip-2"),
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip long (40-80cm) fourni par le Tilliste : réparation / remplacement',
      prices: {
        DEFAULT: 47
      },
      id: "14.".concat(slug, "-rep-zip-3"),
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip court (< 25cm) fourni par le client : réparation / remplacement',
      prices: {
        DEFAULT: 22
      },
      id: "14.".concat(slug, "-rep-zip-6"),
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip moyen (25-40cm) fourni par le client : réparation / remplacement',
      prices: {
        DEFAULT: 37
      },
      id: "14.".concat(slug, "-rep-zip-11"),
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip long (40-80cm) fourni par le client : réparation / remplacement',
      prices: {
        DEFAULT: 42
      },
      id: "14.".concat(slug, "-rep-zip-7"),
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible court (< 25cm) fourni par le Tilliste : réparation / remplacement',
      prices: {
        DEFAULT: 28
      },
      id: "14.".concat(slug, "-rep-zip-4"),
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
      prices: {
        DEFAULT: 48
      },
      id: "14.".concat(slug, "-rep-zip-10"),
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible long (40-80cm) fourni par le Tilliste : réparation / remplacement',
      prices: {
        DEFAULT: 55
      },
      id: "14.".concat(slug, "-rep-zip-5"),
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible court (< 25cm) fourni par le client : réparation / remplacement',
      prices: {
        DEFAULT: 25
      },
      id: "14.".concat(slug, "-rep-zip-8"),
      multiple: true,
      repairBonus: 'ZIP_SMALL'
    }, {
      name: 'Zip invisible moyen (25-40cm) fourni par le client : réparation / remplacement',
      prices: {
        DEFAULT: 44
      },
      id: "14.".concat(slug, "-rep-zip-12"),
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }, {
      name: 'Zip invisible long (40-80cm) fourni par le client : réparation / remplacement',
      prices: {
        DEFAULT: 50
      },
      id: "14.".concat(slug, "-rep-zip-9"),
      multiple: true,
      repairBonus: 'ZIP_BIG'
    }]
  };
};
var getRepairInteriorButtons = exports.getRepairInteriorButtons = function getRepairInteriorButtons(_ref14) {
  var slug = _ref14.slug;
  return {
    name: 'Boutons',
    slug: 'but_repair',
    items: [{
      name: 'Boutonnière (x1) : création',
      prices: {
        DEFAULT: 3
      },
      id: "14.".concat(slug, "-rep-but-1"),
      isSuitableForJunior: true,
      multiple: true
    }, {
      name: 'Bouton (x1) fourni par le Tilliste',
      prices: {
        DEFAULT: 3
      },
      id: "14.".concat(slug, "-rep-but-2"),
      isSuitableForJunior: true,
      multiple: true
    }, {
      name: 'Bouton (x1) fourni par le client',
      prices: {
        DEFAULT: 2
      },
      id: "14.".concat(slug, "-rep-but-3"),
      isSuitableForJunior: true,
      multiple: true
    }, {
      name: 'Bouton pression à coudre (x1) fourni par le Tilliste',
      prices: {
        DEFAULT: 3
      },
      id: "14.".concat(slug, "-rep-but-4"),
      isSuitableForJunior: true,
      multiple: true
    }, {
      name: 'Bouton pression à coudre (x1) fourni par le client',
      prices: {
        DEFAULT: 2
      },
      id: "14.".concat(slug, "-rep-but-5"),
      isSuitableForJunior: true,
      multiple: true
    }, {
      name: 'Bouton pression à poser (x1) fourni par le Tilliste',
      prices: {
        DEFAULT: 8
      },
      id: "14.".concat(slug, "-rep-but-6"),
      isSuitableForJunior: true,
      multiple: true
    }, {
      name: 'Bouton pression à poser (x1) fourni par le client',
      prices: {
        DEFAULT: 6
      },
      id: "14.".concat(slug, "-rep-but-7"),
      isSuitableForJunior: true,
      multiple: true
    }]
  };
};